<template>
  <section id="videos" class="py-36">
      <div class="text-center w-full text-gray-800">
        <h3 class="about text-3xl md:text-6xl ">ALL TRAININGS</h3>
        <p class="pt-5 text-xl w-11/12 md:w-9/12 mx-auto">Choose your desired program </p>
      </div>
      <div class="md:flex gap-2 w-11/12 lg:w-9/12 mt-12 mx-auto items-center flex-wrap justify-center">
        <vs-card actionable class="cardx w-full md:w-5/12 lg:w-3/12 mx-2">
          <div slot="header">
            <h3 class="about font-bold text-2xl text-center"> Flash Abs </h3>
          </div>
          <div slot="media">
            <img class="h-56 object-cover" style="filter: grayscale(80%)" src='../assets/abs.jpg'>
          </div>
          <div slot="footer" class="mt-5">
            <vs-row vs-justify="center">
              <vs-button color="dark" type="relief" @click="redirectTo('flash-abs')">Commence</vs-button>
            </vs-row>
          </div>
        </vs-card>
        <vs-card actionable class="cardx w-full md:w-5/12 lg:w-3/12 mx-2">
          <div slot="header">
            <h3 class="about font-bold text-2xl text-center"> Cardio Fit </h3>
          </div>
          <div slot="media">
            <img class="h-56 object-cover" style="filter: grayscale(80%)" src='../assets/cardio.jpg'>
          </div>
          <div slot="footer" class="mt-5">
            <vs-row vs-justify="center">
              <vs-button color="gray" style="opacity: 1;" type="relief" disabled >Commence</vs-button>
            </vs-row>
          </div>
        </vs-card>
        <vs-card actionable class="cardx w-full md:w-5/12 lg:w-3/12 mx-2">
          <div slot="header">
            <h3 class="about font-bold text-2xl text-center"> Fit Boxing </h3>
          </div>
          <div slot="media">
            <img class="h-56 object-cover" style="filter: grayscale(80%)" src='../assets/boxing.jpg'>
          </div>
          <div slot="footer" class="mt-5">
            <vs-row vs-justify="center">
               <vs-button color="gray" style="opacity: 1;" type="relief" disabled >Commence</vs-button>
            </vs-row>
          </div>
        </vs-card>
        <vs-card actionable class="cardx w-full md:w-5/12 lg:w-3/12 mx-2">
          <div slot="header">
            <h3 class="about font-bold text-2xl text-center"> Yoga </h3>
          </div>
          <div slot="media">
            <img class="h-56 object-cover" style="filter: grayscale(80%)" src='../assets/yoga.jpg'>
          </div>
          <div slot="footer" class="mt-5">
            <vs-row vs-justify="center">
              <vs-button color="gray" style="opacity: 1;" type="relief" disabled >Commence</vs-button>
            </vs-row>
          </div>
        </vs-card>
      </div>
    </section>
</template>

<script>
export default {
  methods:{
    redirectTo(route){
      if(route === 'flash-abs'){
        this.$store.dispatch('videoCategory', { category: 'Flash Abs'})
      }
      setTimeout(() => {
        this.$router.push({name: 'TrainingVideos', params: { id: route }})
      }, 100);
    }
  }

}
</script>

<style>

</style>